module.exports = __webpack_public_path__ + "fonts/font-icon-Enerdata.d7bec6f.eot";